<template>
  <div class="wild-card-info-item">
    <div class="wild-card-info-item__label"><slot name="label" /></div>
    <div class="wild-card-info-item__value ellipsis"><slot /></div>
  </div>
</template>

<script>
export default {
  name: "WildCardInfoItem"
};
</script>

<style lang="scss">
.wild-card-info-item {
  flex: 1 0 0;

  min-width: 0;

  &:nth-child(2n-1) {
    margin-right: 25px;
  }

  &__label {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 12px;
    white-space: nowrap;
  }

  &__value {
    background: rgba(0, 10, 37, 0.5);
    border-radius: 6px;
    padding: 8px;
    overflow: hidden;
    font-weight: 800;
    font-size: 14px;
    line-height: 108.95%;
    letter-spacing: 0.02em;
  }

  @include breakpoint("md-only") {
    &:nth-child(2n-1) {
      margin-right: 15px;
    }
    &__label {
      font-size: 11px;
    }
    &__value {
      font-size: 12px;
    }
  }

  @include breakpoint("sm-and-down") {
    &:nth-child(2n-1) {
      margin-right: 15px;
    }
    &__label {
      font-size: 11px;
    }
    &__value {
      font-size: 12px;
    }
  }
}
</style>
